import { render, staticRenderFns } from "./tenants-table.vue?vue&type=template&id=c1cc556c"
import script from "./tenants-table.ts?vue&type=script&lang=js&external"
export * from "./tenants-table.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports